import {EventEmitter, Injectable, Output} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map, Observable} from "rxjs";
import {User} from "../_models/user";
import {Router} from "@angular/router";
import {convertSystemRoleToEnum} from "../_util/utils";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggingOut = false;

  @Output() currentUser$: EventEmitter<User | null> = new EventEmitter<User | null>();

  constructor(private http: HttpClient,
              private router: Router) { }
  login(loginData: any): Observable<any> {
    let formData = new FormData();
    formData.append("email", loginData.email);
    formData.append("password", loginData.password);
    formData.append("remember_me", loginData.remember_me);
    return this.http.post<User>(`${environment.serverUrl}/login`, formData, {withCredentials: true}).pipe(
      map((user) => {
        user.systemRole = convertSystemRoleToEnum(user.systemRole);
        this.currentUser$.emit(user);
        return user;
    }));
  }

  logout(redirectBackAfterLogin = false) {
    const returnUrl = window.location.pathname + window.location.search;

    if (this.isLoggingOut || this.router.url.startsWith('/login')) return;
    this.isLoggingOut = true;

    this.makeLogoutRequest().subscribe(() => {
      this.currentUser$.emit(null);

      if (redirectBackAfterLogin) this.router.navigateByUrl(`/login?returnUrl=${redirectBackAfterLogin ? returnUrl: ''}`);
      else this.router.navigateByUrl(`/login`);

      this.isLoggingOut = false;
    })
  }

  makeLogoutRequest(){
    return this.http.post(`${environment.serverUrl}/logout`, '', {observe: "response", withCredentials: true});
  }
}
